import React, { useEffect, useState } from 'react';
import { getCardImageUrl } from '../../utils/cardImages';

/**
 * The card art shown inside a tooltip. Mounted only while a card link is
 * hovered, so unlike CardImage there is nothing to lazy-load — it resolves the
 * image immediately and keeps it cached for the next hover.
 */
const CardHoverPreview = ({ name }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setImageUrl(null);
    setFailed(false);
    getCardImageUrl(name).then(url => {
      if (cancelled) return;
      if (url) setImageUrl(url);
      else setFailed(true);
    });
    return () => {
      cancelled = true;
    };
  }, [name]);

  if (failed) {
    return <span className="text-xs">{name}</span>;
  }

  return (
    <img
      className="bg-transparent rounded-[16px] w-56 max-w-none block"
      src={imageUrl || '/img/placeholder.webp'}
      alt={name}
    />
  );
};

export default CardHoverPreview;
